/* import __COLOCATED_TEMPLATE__ from './project-name-conflict-alert.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();